import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-data",
  "use": "icon-data-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-data\"><defs><style type=\"text/css\"></style></defs><path d=\"M227.556 113.778h113.777v56.889H227.556z m0 341.333h113.777V512H227.556z m0 341.333h113.777v56.89H227.556z\" fill=\"#73777A\" p-id=\"2178\" /><path d=\"M853.333 56.889v170.667H170.667V56.889h682.666M910.223 0H113.777v284.444h796.444V0z m-56.89 398.222V568.89H170.667V398.222h682.666m56.89-56.889H113.777v284.445h796.444V341.333z m-56.89 398.223v170.666H170.667V739.556h682.666m56.89-56.89H113.777v284.445h796.444V682.667z\" fill=\"#73777A\" p-id=\"2179\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/data.svg
// module id = RUrO
// module chunks = 5